// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1o89q","logo_image":"Logo_logo_image__3kipp","logo_text":"Logo_logo_text__2Osyy"};